import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@feathr/components';

interface IDownloadErrorsLineProps {
  /** The importer's error-file download URL. */
  href: string;
}

/** The run's error-file download. The panel renders it only when the import has an error file. */
function DownloadErrorsLine({ href }: Readonly<IDownloadErrorsLineProps>): JSX.Element {
  const { t } = useTranslation();

  // Placeholder copy, pending Product and Design.
  return (
    <Button href={href} name={'import-run-details-download-errors'} type={'link'}>
      {t('Download file')}
    </Button>
  );
}

export default DownloadErrorsLine;
